import $http from './index.js'
export const ImportFile = (data) => {
  return $http.post('api/Register/ImportFile', data)
}
export const Save = (data) => {
  return $http.post('api/RegistrationForm/Save', data)
}
export const GetUserRegistrationForm = (data) => {
  return $http.post('api/RegistrationForm/GetUserRegistrationForm', data)
}

export const SaveEducationReform = (data) => {
  return $http.post('api/RegistrationForm/SaveEducationReform', data)
}
export const GetUserEducationReform = (data) => {
  return $http.post('api/RegistrationForm/GetUserEducationReform', data)
}

export const SaveEducationReformSubmit = (request) => {
  return $http.post('api/RegistrationForm/SaveEducationReformSubmit', request)
}
export const GetUserEducationSubmitReform = (data) => {
  return $http.post('api/RegistrationForm/GetUserEducationSubmitReform', data)
}
export const GetEducationReformSubmitPageList = (data) => {
  return $http.post(
    'api/RegistrationForm/GetEducationReformSubmitPageList',
    data
  )
}
export const GetEducationReformSubmitSingle = (data) => {
  return $http.post('api/RegistrationForm/GetEducationReformSubmitSingle', data)
}

export const GetUserEducationSubmitReformList = (data) => {
  return $http.post(
    'api/RegistrationForm/GetUserEducationSubmitReformList',
    data
  )
}
export const GetEducationReformById = (data) => {
  return $http.post('api/RegistrationForm/GetEducationReformById', data)
}
